export default "__VITE_PUBLIC_ASSET__f92e1fa6__"